import { SHOW_SNACKBAR, HIDE_SNACKBAR, RESET_SNACKBAR } from "./actionTypes";

export const actions = {
  showSnackbar: (payload) => ({
    type: SHOW_SNACKBAR,
    payload,
  }),
  hideSnackbar: () => ({
    type: HIDE_SNACKBAR,
  }),
  resetSnackbar: () => ({
    type: RESET_SNACKBAR,
  }),
};

const initialState = {
  shouldShow: false,
  message: "Error",
  position: "bottom",
  bottom: 45,
  autoHidingTime: 3000,
  autoHide: true,
  actionText: "Okay",
  actionHandler: (e) => {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_SNACKBAR:
      const { message, position, bottom, autoHide, actionText, actionHandler } =
        action.payload;

      return {
        ...state,
        message,
        shouldShow: true,
        position,
        bottom,
        autoHide,
        actionText,
        actionHandler,
      };
    case HIDE_SNACKBAR:
      return {
        ...state,
        message: "",
        shouldShow: false,
      };

    case RESET_SNACKBAR: {
      return initialState;
    }
  }
  return state;
};
reducer.initialState = initialState;

export default reducer;
